export default __webpack_public_path__ + "static/media/Office03.1e363a6a.jpg";